import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/mutu/outpatient-waiting";

// ==================== SESSIONS (CRUD) ====================
async function getList(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/sessions`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http
    .getData(`${BASE}/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function create(data: any) {
  const response = await http
    .postData(`${BASE}/sessions`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/sessions/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`${BASE}/sessions/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== OBSERVATIONS ====================
async function storeObservations(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/observations`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function importAntrean(sessionId: number, data?: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/import-antrean`, data || {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== RTL ====================
async function storeRtl(sessionId: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${sessionId}/rtl`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== SUBMIT & 3-TIER SIGN ====================
async function submit(id: number, data: any) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/submit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signVerifikator(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/sign-verifikator`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKepalaUnit(id: number, data: { password: string }) {
  const response = await http
    .postData(`${BASE}/sessions/${id}/sign-kepala-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== LOOKUPS ====================
async function getPoliklinik() {
  const response = await http
    .getData(`${BASE}/poliklinik`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function lookupPatient(registerId: number) {
  const response = await http
    .getData(`${BASE}/lookup-patient/${registerId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function lookupPatientByRm(rm: string) {
  const response = await http
    .getData(`${BASE}/lookup-patient-rm/${rm}`)
    .catch(err => {
      // silent fail — don't show error alert for lookup misses
      return Promise.reject(err);
    });
  return response;
}

// ==================== DASHBOARD & REKAP ====================
async function getDashboard(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/dashboard`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getRekapHarian(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/rekap-harian`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getHeatmapPoli(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/heatmap-poli`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== MONTHLY REPORT ====================
async function getMonthly(tahun: number, bulan: number) {
  const response = await http
    .getData(`${BASE}/monthly/${tahun}/${bulan}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function finalizeMonthly(tahun: number, bulan: number, data: any) {
  const response = await http
    .postData(`${BASE}/monthly/${tahun}/${bulan}/finalize`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function triggerAggregate(tahun: number, bulan: number) {
  const response = await http
    .postData(`${BASE}/monthly/${tahun}/${bulan}/trigger-aggregate`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// ==================== PDF ====================
function printPdf(id: number) {
  window.open(
    `${http.getAPI()}${BASE}/sessions/${id}/pdf`,
    "_blank"
  );
}

export default {
  getList,
  find,
  create,
  update,
  destroy,
  storeObservations,
  importAntrean,
  storeRtl,
  submit,
  signVerifikator,
  signKepalaUnit,
  getPoliklinik,
  lookupPatient,
  lookupPatientByRm,
  getDashboard,
  getRekapHarian,
  getHeatmapPoli,
  getMonthly,
  finalizeMonthly,
  triggerAggregate,
  printPdf,
};
